import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-carousel', {
  onLoad() {
    const thisSlider = this.container.querySelector('.featured-carousel__slider');

    const settings = this.container.dataset.sliderSettings || '{}';
    const sliderSettings = JSON.parse(settings);
    const sliderAutoplay = sliderSettings && sliderSettings.autoplay ? sliderSettings.autoplay * 1000 : false;

    if (!thisSlider) return;

    // eslint-disable-next-line no-unused-vars
    const flickity = new Flickity(thisSlider, {
      freeScroll: false,
      prevNextButtons: true,
      pageDots: true,
      cellAlign: 'left',
      imagesLoaded: true,
      contain: true,
      groupCells: true,
      autoPlay: sliderAutoplay,
      arrowShape: 'm12.075 51.432 27.04 23.66L36.572 78 4 49.5 36.571 21l2.545 2.908-27.04 23.66H95.8v3.864H12.075Z',
    });
  },
});
